import { AlertTitle, Box, Typography } from "@mui/material"
import { useState } from "react";
import ErrorBox from "../../../../../components/shared/boxes/ErrorBox";

const NFSeEmitError = () => {
    const [open, setOpen] = useState(true);
    if (!open) return null;
    return (
        <Box sx={{ my: 2 }}>
            <ErrorBox
                errorMessage={
                    <>
                        <AlertTitle> Falha na Emissão da Nota Fiscal de Serviço</AlertTitle>
                        <Typography> Por favor, clique no botão "Visualizar nota (NFS-e)" para conferir detalhes e reemitir. </Typography>
                    </>
                }
                onClose={() => setOpen(false)}
            />
        </Box>
    )
}

export default NFSeEmitError;